import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { AccountingEnvironmentEnum, AccountingSystemEnum } from "src/app/core/models/accounting/account-settings.model";
import { DataType } from "src/app/core/models/document/custom-field-base-model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { GlobalComponent } from "src/app/global-component";

export class DocumentTemplatesEditListConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.listTitle = "Custom Fields";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {
                dataFieldName: 'caption',
                title: 'Caption',
                visible: 'true',
                order: 1,
                width: "150px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                dataFieldName: 'name',
                title: 'Name',
                visible: 'true',
                order: 2,
                width: "150px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                dataFieldName: 'value',
                title: 'Value',
                visible: 'true',
                order: 3,
                width: "150px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                dataFieldName: 'dataType',
                title: 'Data Type',
                visible: 'true',
                order: 4,
                width: "150px",
                type: ColumnTypeEnum.InlineEditingDropdown,
                inlineEditingDropDownOptions: [
                    {
                        value: DataType.Text,
                        selectedText: "String",
                        dropdownText: "String"
                    },
                    {
                        value: DataType.Boolean,
                        selectedText: "Boolean",
                        dropdownText: "Boolean"
                    },
                    {
                        value: DataType.Date,
                        selectedText: "Date",
                        dropdownText: "Date"
                    },
                    {
                        value: DataType.DropDown,
                        selectedText: "Dropdown",
                        dropdownText: "Dropdown"
                    },
                ]
            },
            {
                dataFieldName: 'groupName',
                title: 'GroupName',
                visible: 'true',
                order: 5,
                width: "150px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                dataFieldName: 'groupSubName',
                title: 'Group Sub-Name',
                visible: 'true',
                order: 6,
                width: "150px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                dataFieldName: 'order',
                title: 'Order',
                visible: 'true',
                order: 7,
                width: "150px",
                type: ColumnTypeEnum.InlineEditingString
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 8,
                width: "125px",
                type: ColumnTypeEnum.Action
            }
        ]
        this.filters = undefined;
        this.searchbarFilter = undefined;
        this.actions = [
            {
                visible: 'true',
                label: 'Edit Inline',
                actionId: ActionIdEnum.EnableDisable,
                icon: 'ri-edit-box-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [0],
                visibilityByValueIsEnum: true,
                dataFieldName: 'enableInLineEditing'
            },
            {
                visible: 'true',
                label: 'Approve Edits',
                actionId: ActionIdEnum.EnableDisable,
                icon: 'ri-checkbox-circle-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [1],
                visibilityByValueIsEnum: true,
                dataFieldName: 'enableInLineEditing'
            },
            {
                visible: 'true',
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-close-circle-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [1],
                visibilityByValueIsEnum: true,
                dataFieldName: 'enableInLineEditing'
            },
        ]
        this.buttons = [
            {
                visible: 'true',
                label: "Create New",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            },]
        this.enablePagination = false;
        this.canConfigBeSavedToServer = true;
    }
}